module.exports = __webpack_public_path__ + "static/media/logo-supplied.c84b314c.png";